import { ManagerRole } from '../../../../../../hooks/auth/usePermissions';

export default {
  form: {
    title: 'Lisää manageri',
    first_name: {
      label: 'Etunimi',
      placeholder: 'Walter',
    },
    last_name: {
      label: 'Sukunimi',
      placeholder: 'White',
    },
    city: {
      label: 'Kaupunki',
      placeholder: 'Bonn',
    },
    email: {
      label: 'Sähköposti',
      placeholder: 'thedanger@foodamigos.io',
    },
    roles: {
      label: 'Rooli',
      placeholder: 'Valitse rooli',
      // Add-form label for store_admin sent with as_owner; other store admins keep "Admin".
      owner_option: 'Omistaja',
      options: {
        [ManagerRole.Admin]: 'Admin',
        [ManagerRole.Reseller]: 'Jälleenmyyjä',
        [ManagerRole.SalesManager]: 'Myyntipäällikkö',
        [ManagerRole.SalesLeadership]: 'Myynnin johtaja',
        [ManagerRole.ContentManager]: 'Sisältöpäällikkö',
        [ManagerRole.OnboardingManager]: 'Käyttöönottopäällikkö',
        [ManagerRole.MobileAppsManager]: 'Mobiilisovellusten päällikkö',
        [ManagerRole.StoreAdmin]: 'Admin',
        [ManagerRole.StoreEmployee]: 'Työntekijä',
        [ManagerRole.StoreOperator]: 'Operaattori',
        [ManagerRole.SDR]: 'SDR',
      },
      description: {
        [ManagerRole.StoreOperator]:
          '<strong>Operaattori:</strong> Täysi pääsy Myyntiin, Valikkoon, Suosituimpiin tuotteisiin, Aukioloaikoihin, Lahjakortteihin, Varauksiin ja Raportteihin nimetyille yrityksille.',
        [ManagerRole.StoreEmployee]: '<strong>Työntekijä:</strong> Rajattu pääsy vain Varauksiin ja Lahjakortteihin.',
        [ManagerRole.StoreAdmin]:
          '<strong>Omistaja:</strong> Täysi pääsy yhteen ravintolaan, mukaan lukien Storefront, veroasetukset, markkinointi ja tiiminhallinta. Saa sähköpostin kirjautumistiedoillaan. Yhdellä ravintolalla on vain yksi omistaja, eivätkä muut tiimin jäsenet voi muokata tai poistaa häntä.',
      },
    },
    companies: {
      label: 'Yritykset',
      placeholder: 'Valitse yritykset',
      owner_placeholder: 'Valitse ravintola',
      has_owner: 'On omistaja',
    },
  },
  fields: {
    email: 'Sähköposti',
    name: 'Nimi',
    roles: 'Rooli',
    created_at: 'Luotu',
    actions: 'Toiminnot',
    companies: 'Yritykset',
    status: 'Tila',
  },
  tags: {
    owner: 'Omistaja',
  },
  search: {
    placeholder: 'Hae nimellä tai sähköpostilla',
  },
  buttons: {
    add_manager: 'Lisää manageri',
    actions: 'Toiminnot',
    view_dashboard: 'Näytä hallintapaneeli tämän managerin näkökulmasta',
    login_as_manager: 'Kirjaudu sisään tämän managerin tunnuksilla',
    delete: 'Poista tämä manageri',
    resend_owner_invite: 'Lähetä omistajan kutsu uudelleen',
  },
  modals: {
    delete_manager: {
      title: 'Haluatko varmasti poistaa managerin {{email}}?',
    },
    update_manager: {
      title: 'Haluatko varmasti päivittää managerin {{email}}?',
    },
    resend_owner_invite: {
      title: 'Lähetetäänkö kutsu uudelleen osoitteeseen {{email}}?',
      description: 'Omistaja saa uuden salasanan sähköpostitse. Nykyinen salasana lakkaa toimimasta.',
    },
  },
  toasts: {
    successfully_created_manager: 'Manageri luotiin onnistuneesti',
    owner_invited: '{{email}} on kutsuttu ravintolan omistajaksi ja saa kirjautumistietonsa sähköpostitse.',
    failed_to_load_data: 'Tietojen lataaminen epäonnistui, päivitä sivu',
    failed_to_create_manager: 'Managerin luominen epäonnistui',
    failed_to_create_magic_link: 'Taikalinkin luominen epäonnistui',
    failed_to_delete_manager: 'Managerin poistaminen epäonnistui',
    manager_got_deleted: 'Manageri poistettiin',
    successfully_updated_manager: 'Manageri päivitettiin',
    failed_to_update_manager: 'Managerin päivittäminen epäonnistui',
    owner_invite_resent: 'Kutsu lähetettiin osoitteeseen {{email}} uudelleen uudella salasanalla.',
    owner_invite_resend_cooling_down:
      'Kutsu lähetettiin juuri uudelleen. Odota muutama minuutti ennen kuin lähetät sen uudelleen.',
    failed_to_resend_owner_invite: 'Kutsun uudelleenlähetys epäonnistui',
  },
};
